import { selfAxios } from "../../../../../axios/selfAxios.js";
async function postNewGetSpecialPageByCon(params) {
  const { data } = await selfAxios.post(`/designapi/design/special/newGetSpecialPageByCon`, params, { _cache: true });
  return data == null ? void 0 : data.data;
}
export { postNewGetSpecialPageByCon };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/request/designapi/design/special/newGetSpecialPageByCon/post.js